import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { getDelayOfPopupSignUp } from 'helpers/getDelayOfPopupSignUp';
import { setSearchParam } from 'helpers/setSearchParam';
import { isCasinoGamePage } from 'utils';

import { SessionStorageManager, SiteConfigManager, useApplicationState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import { POPUP_SIGN_UP_DELAY_STORAGE_KEYS } from 'common/constants';
import { defaultRoutes } from 'components/MainRouter/constants';

const { forgotPassword, resetPassword, signin, signup } = defaultRoutes;
const { NEXT_SHOW, TIMEOUT_ID } = POPUP_SIGN_UP_DELAY_STORAGE_KEYS;

export const useShowPopupSignUpDelay = () => {
  const { authenticated, loading } = useApplicationState();
  const history = useHistory();
  const {
    location: { pathname },
  } = history;
  const casinoPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO);
  const casinoLivePath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.CASINO_LIVE);

  const isNotCasinoGamePage = useMemo(
    () => !isCasinoGamePage(pathname, [casinoPath, casinoLivePath]),
    [pathname],
  );

  useEffect(() => {
    const enableSignUpDelay = SiteConfigManager.getConfig(
      'config.config.registration.mobile_popup',
    );
    let timeoutId;

    if (enableSignUpDelay) {
      const { pathname, search } = history.location;
      const isAuth = [signin, signup, resetPassword, forgotPassword].includes(pathname);
      const isSignUpDelay = search.includes('cmd=signup-delay');
      const isSignUpPopup = search.includes('cmd=signup');
      const isEmailVerification = search.includes('cmd=emailVerification');
      const showPopup =
        !isAuth && !isSignUpDelay && !isSignUpPopup && !isEmailVerification && isNotCasinoGamePage;

      if (showPopup) {
        const delay = getDelayOfPopupSignUp();

        timeoutId = setTimeout(() => {
          SessionStorageManager.removeItem(TIMEOUT_ID);
          const { search } = history.location;
          const newSearch = setSearchParam(search, 'cmd', 'signup-delay');

          history.push({ search: newSearch });
        }, delay);

        SessionStorageManager.setItem(TIMEOUT_ID, timeoutId);
      }
    } else {
      const sessionTimeoutId = SessionStorageManager.getItem(TIMEOUT_ID);
      if (sessionTimeoutId) {
        clearTimeout(sessionTimeoutId);
        SessionStorageManager.removeItem(TIMEOUT_ID);
      }
      SessionStorageManager.removeItem(NEXT_SHOW);
    }

    if (authenticated) {
      clearTimeout(timeoutId);
      SessionStorageManager.removeItem(TIMEOUT_ID);
    }

    return () => {
      clearTimeout(timeoutId);
      SessionStorageManager.removeItem(TIMEOUT_ID);
    };
  }, [authenticated, history, loading, isNotCasinoGamePage]);
};
